<template>
  <div class="setname">
    <div class="bg">
      <div class="shopname">
          <input type="text" v-model="shopname">
      </div>
      <div class="btn">
        <img src="../../../assets/images/active/login.png" alt class="btn_image">
        <p class="font">确定</p>
        <div class="mocen" @click="openshop"></div>
      </div>
        <div class="motailin" v-show="isMotial">
          <p class="title">{{message}}</p>
          <p class="queren" @click="setname" >确认</p>
        </div>
    </div>
  </div>
</template>
<script>
import axios from "axios"
export default {
  data() {
    return {
      shopname:"",
      isMotial:false,
      message:""
    };
  },
  created(){
     document.getElementsByTagName("title")[0].innerText = "我是谜520表白商店";
  },
  methods:{
    setname(){
      this.isMotial=false
    },
    openshop(){
      if(!this.shopname){
        this.isMotial=true
        setTimeout(()=>{
          this.isMotial=false
        },2000)
        this.message = "请输入店铺名称"
        return
      }
        axios.post(this.$interfaces.saveUserActivityLoveShopName,{
              userGuid:this.$store.state.userguid,
              token:this.$store.state.token,
              shopName:this.shopname
            }).then(res=>{
              if(res.data.code!==200){
                this.isMotial=true
                if(res.data.code == 400){
                   this.$router.push({ path: "/login" });
                   return
                }
                var code = res.data.code                 
                    if(code == 900005 || code == 900000 || code == 900001 || code == 500006){
                        this.isMotial=true
                        this.message = res.data.message
                        return 
                    }
              }else{
                this.$router.push({path:"/home"})
                localStorage.setItem("shopname",this.shopname)
                this.$store.dispatch('ShopName',this.shopname)
              }
                

            }).catch(err=>{
              console.log(err)
            })
      }
        
        
  }
};
</script>
<style scoped>
.setname {
  width: 100%;
  height: 100%;
}
.setname .bg {
   background:url("../../../assets/images/active/bg/shopname.png")
    no-repeat left top;
    background-size: cover;
    height:33.35rem;
    position: relative;
    text-align: center;
    display: flex;
    justify-content: center;
}
.setname .bg .shoopname{
  position:absolute;
  top:12.425rem;
  width:7.5rem;
  color:white
}
.setname .bg  .motailin{
  padding-top:0.5rem;
  position: absolute;
  top:60%;
  width: 6rem;
  height: 3.75rem;
  background:white;
  border-radius: 0.5rem;
}
.setname .bg  .motailin .title{
  font-size:0.625rem;
  margin-bottom:0.75rem;
}
.setname .bg  .motailin .queren{
  color:red;
}
.setname .bg .shopname {
  position:absolute;
  top:13.5rem;
  width:15.5rem;
  height: 2.5rem;
  overflow: hidden;
  padding-top:0.25rem;
  padding-bottom:0.25rem;
  border-radius: 1.25rem;
}
.setname .bg .shopname input{
    text-align: center;
    border:none;
    width:15.5rem;
    height: 2rem;
    font-size:0.85rem;
    font-family:SourceHanSansCN-Regular;
    font-weight:400;
    color:rgba(255,63,139,1);
    line-height:1rem;
    caret-color:rgba(0,0,0,.2);

}
.setname .bg .btn{
    position: absolute;
    top:17rem;
    width:16rem;
    height: 3rem;
    text-align: center;
    line-height: 3rem;
    color:white;
    font-size: 1rem;
}
.setname .bg .btn .mocen{
    position:absolute;
    top:0;
    left:0;
    width:16rem;
    height: 3rem;
    /* background:pink */

}
.setname .bg .btn .font{
    position: absolute;
    top:0;
    left:0;
    width:16rem;
    height: 3rem;
    text-align: center;
    line-height: 3rem;
    color:white;
    font-size: 1rem;
}
.setname .bg .btn img{
    width:100%;
    height: 100%;
}
</style>




// WEBPACK FOOTER //
// src/components/active/view/setname.vue